﻿import { WrapperGS } from "./WrapperGS";
import { RuntimeGS } from './app/RuntimeGS';

export class GS
{
    private _all:WrapperGS[];

    public static Query(selector: any): GS { return new GS(selector); }

    constructor(selector: any, inElement?: Element)
    {
        const type = typeof (selector);
        this._all = [];

        const tAll = this._all;
        function savePush(e: any) { const wr = WrapperGS.Wrap(e); if (wr) tAll.push(wr); }
        
        switch (type) {
            case 'string':
                if (inElement) inElement.querySelectorAll(selector).forEach(e => savePush(e)); else
                    RuntimeGS.document.querySelectorAll(selector).forEach(e => savePush(e));
                break;
            case 'object': savePush(selector); break;
        }
    }

    get all() { return [...this._all];}
    get first(): WrapperGS | undefined { return this._all[0] }
    get last(): WrapperGS | undefined { return this._all[this._all.length-1]; }

    forEach(callbackfn: (value: WrapperGS, index: number, array: WrapperGS[]) => void, thisArg?: any): void { this.all.forEach(callbackfn, thisArg); }
    
    text(value: string) { this.forEach(w => w.text = value) }    
    html(value: string) { this.forEach(w => w.html = value) }

    disable() { this.forEach(w => w.disable()); };
    enable() { this.forEach(w => w.enable()); };
    enableFlip() { this.forEach(w => w.enableFlip()); };
    enableSet(value:boolean) { this.forEach(w => w.enableSet(value)); };

    hide() { this.forEach(w => w.hide()); }
    show() { this.forEach(w => w.show()); }
    showFlip() { this.forEach(w => w.showFlip()); };
    showSet(value:boolean) { this.forEach(w => w.showSet(value)); };

    inactive() { this.forEach(w => w.inactive()); };
    active() { this.forEach(w => w.active()); };
    activeFlip() { this.forEach(w => w.activeFlip()); };
    activeSet(value:boolean){ this.forEach(w => w.activeSet(value)); }

    addClass(className: string) { this.forEach(i => i.addClass(className)); };
    removeClass(className: string) { this.forEach(i => i.removeClass(className)); };

    cut() { this.forEach(i => i.cut()); };
}
